var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"container-full-bg-gray",attrs:{"fluid":""}},[_c('CreationObject',{attrs:{"objectType":_vm.objectType,"objectName":"Empresa","url":_vm.url,"id":_vm.company,"inputs":_vm.inputs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }